import {useLocation} from 'react-router-dom';
import resolvePath from '../../misc/resolvePath';

export function useFallbackRoute(relativePathname = '..') {
    const {pathname} = useLocation();
    return resolvePath(pathname, relativePathname);
}
